export default "__VITE_ASSET__df00fbe3__"